import { NotificationState, notificationActions } from '@om1/platform-notifications'
import { connectRedux } from '@om1/platform-utils'
import { HelpDialogComponent } from './HelpDialogComponent'

export function createHelpDialog<TState extends { notification: NotificationState }>() {
    return connectRedux(HelpDialogComponent, (state: TState) => state.notification, { ...notificationActions })
}

export type HelpDialog = ReturnType<typeof createHelpDialog>
